// Shared style constants based on Figma design system

export const buttonStyles = {
  primary:
    'bg-green-medium hover:bg-green-dark text-white font-semibold py-4 px-8 rounded-full transition-all duration-300 shadow-md hover:shadow-lg cursor-pointer md:w-[240px]',
  secondary:
    'bg-white border-2 border-green-medium text-green-medium hover:bg-green-light hover:text-white font-semibold py-4 px-8 rounded-full transition-all duration-300 cursor-pointer',
  disabled: 'bg-gray-300 text-gray-500 font-semibold py-4 px-8 rounded-full cursor-not-allowed opacity-50',
  small: 'py-3 px-6 text-sm',
  large: 'py-4 px-8',
};

export const inputStyles = {
  base: 'w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-purple-medium focus:outline-none transition-colors bg-white text-gray-700 placeholder-gray-400',
  error: 'border-red-500 focus:border-red-500',
  select:
    'w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-purple-medium focus:outline-none transition-colors bg-white text-gray-700 appearance-none',
};

export const labelStyles = {
  base: 'block text-sm font-medium text-gray-700 mb-2',
  required: "after:content-['*'] after:ml-0.5 after:text-red-500",
};

export const cardStyles = {
  base: 'bg-white rounded-2xl shadow-sm p-6',
  hover: 'hover:shadow-md transition-shadow duration-300',
  selected: 'border-2 border-purple-medium shadow-md',
};

export const recipientCardStyles = {
  container: 'relative bg-white rounded-2xl shadow-sm p-8 pt-12 border border-gray-100',
  badge: 'absolute -top-5 left-8 bg-purple-medium text-white px-6 py-3 rounded-full text-sm font-semibold',
  removeButton:
    'absolute top-4 right-4 w-8 h-8 rounded-full bg-red-50 hover:bg-red-100 text-red-600 flex items-center justify-center transition-colors cursor-pointer',
};

export const progressBarStyles = {
  container: 'relative w-full bg-white shadow-sm rounded-full h-24 border-2 border-transparent',
  stepActive: 'w-8 h-8 rounded-full bg-purple-medium text-white flex items-center justify-center',
  stepCompleted: 'w-8 h-8 rounded-full bg-purple-medium text-white flex items-center justify-center',
  stepUpcoming: 'w-8 h-8 rounded-full bg-white border-2 border-gray-300 flex items-center justify-center',
  stepNext: 'w-8 h-8 rounded-full bg-white border-2 border-purple-medium flex items-center justify-center',
  line: 'h-0.5 bg-gray-300',
  lineCompleted: 'h-0.5 bg-purple-medium',
  counter:
    'absolute bottom-0 left-16 transform translate-y-1/2 bg-white px-4 py-2 rounded-full text-sm text-green-medium font-medium shadow-sm',
};

export const pageStyles = {
  title: 'text-3xl font-bold text-purple-medium text-center mb-4',
  subtitle: 'text-lg text-gray-600 text-center mb-8 max-w-2xl mx-auto',
  section: 'mb-8',
  sectionTitle: 'text-xl font-semibold text-gray-800 mb-4',
};
